import React, { useState } from 'react';
import { aduanData } from '../../data/aduanData';
import {
    FaExternalLinkAlt,
    FaPhone,
    FaEnvelope,
    FaWhatsapp,
    FaClock,
    FaCheckCircle,
    FaShieldAlt,
    FaHeadset,
    FaSearch,
    FaCalendarCheck,
    FaClipboardList,
    FaUserCheck,
    FaPaperPlane,
    FaInfoCircle,
    FaArrowRight,
    FaStar
} from 'react-icons/fa';

const AduanPage = () => {
    const [selectedChannel, setSelectedChannel] = useState(null);
    const [activeTab, setActiveTab] = useState('kanal');

    const tabs = [
        { id: 'kanal', label: 'Kanal Pengaduan', icon: FaHeadset },
        { id: 'mekanisme', label: 'Mekanisme', icon: FaClipboardList },
        { id: 'panduan', label: 'Panduan', icon: FaInfoCircle }
    ];

    return (
        <div className="container mx-auto px-4 py-12">
            {/* Header */}
            <div className="mb-8">
                <div className="flex items-center space-x-3 mb-4">
                    <FaHeadset className="text-4xl text-[#0D9488]" />
                    <div>
                        <h1 className="text-3xl md:text-4xl font-bold text-[#1E3A8A]">
                            Layanan Pengaduan
                        </h1>
                        <p className="text-gray-600 mt-1">
                            Sampaikan pengaduan, aspirasi, dan masukan Anda untuk pelayanan yang lebih baik
                        </p>
                    </div>
                </div>
            </div>

            {/* Tab Navigation */}
            <div className="flex flex-wrap gap-2 mb-8 border-b border-gray-200">
                {tabs.map((tab) => (
                    <button
                        key={tab.id}
                        onClick={() => setActiveTab(tab.id)}
                        className={`flex items-center px-6 py-3 text-sm font-medium transition-all duration-200 border-b-2 ${activeTab === tab.id
                                ? 'border-[#0D9488] text-[#0D9488] bg-[#0D9488]/5'
                                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                            }`}
                    >
                        <tab.icon className="mr-2" />
                        {tab.label}
                    </button>
                ))}
            </div>

            {/* Kanal Pengaduan */}
            {activeTab === 'kanal' && (
                <div>
                    {/* Info Cards */}
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
                        <div className="card-glass text-center">
                            <FaShieldAlt className="text-4xl text-[#0D9488] mx-auto mb-3" />
                            <h3 className="font-bold text-[#1E3A8A] mb-2">Dijamin Aman</h3>
                            <p className="text-sm text-gray-600">Identitas pelapor dijamin kerahasiaannya sesuai undang-undang</p>
                        </div>
                        <div className="card-glass text-center">
                            <FaClock className="text-4xl text-[#0D9488] mx-auto mb-3" />
                            <h3 className="font-bold text-[#1E3A8A] mb-2">Respon Cepat</h3>
                            <p className="text-sm text-gray-600">Pengaduan ditanggapi maksimal 5 hari kerja</p>
                        </div>
                        <div className="card-glass text-center">
                            <FaCheckCircle className="text-4xl text-[#0D9488] mx-auto mb-3" />
                            <h3 className="font-bold text-[#1E3A8A] mb-2">GRATIS</h3>
                            <p className="text-sm text-gray-600">Semua layanan pengaduan tidak dipungut biaya</p>
                        </div>
                    </div>

                    {/* Channel Cards */}
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                        {aduanData.channels.map((channel) => (
                            <div
                                key={channel.id}
                                className="card-glass overflow-hidden hover:shadow-xl transition-all duration-300 group cursor-pointer"
                                onClick={() => setSelectedChannel(channel)}
                            >
                                <div className={`bg-gradient-to-r ${channel.color} p-6 text-white relative`}>
                                    <div className="text-5xl mb-3">{channel.icon}</div>
                                    <h3 className="text-xl font-bold">{channel.name}</h3>
                                    <p className="text-sm opacity-90 mt-1">{channel.fullName}</p>
                                    <div className="absolute top-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity">
                                        <FaArrowRight className="text-2xl" />
                                    </div>
                                </div>
                                <div className="p-6">
                                    <p className="text-gray-600 text-sm mb-4">{channel.description}</p>

                                    {channel.website && (
                                        <a
                                            href={channel.website}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="flex items-center text-[#0D9488] hover:text-[#0F766E] font-semibold text-sm mb-3"
                                            onClick={(e) => e.stopPropagation()}
                                        >
                                            <FaExternalLinkAlt className="mr-2" />
                                            Kunjungi Website
                                        </a>
                                    )}

                                    <div className="flex items-center text-sm text-gray-500">
                                        {channel.id === 'whatsapp' ? (
                                            <FaWhatsapp className="mr-2 text-green-500" />
                                        ) : channel.id === 'email' ? (
                                            <FaEnvelope className="mr-2 text-purple-500" />
                                        ) : channel.id === 'telepon' ? (
                                            <FaPhone className="mr-2 text-orange-500" />
                                        ) : (
                                            <FaHeadset className="mr-2 text-[#0D9488]" />
                                        )}
                                        {channel.contact}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Channel Detail Modal */}
                    {selectedChannel && (
                        <div
                            className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 p-4"
                            onClick={() => setSelectedChannel(null)}
                        >
                            <div
                                className="bg-white rounded-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto"
                                onClick={(e) => e.stopPropagation()}
                            >
                                <div className={`bg-gradient-to-r ${selectedChannel.color} p-8 text-white relative`}>
                                    <button
                                        onClick={() => setSelectedChannel(null)}
                                        className="absolute top-4 right-4 bg-white/20 hover:bg-white/30 text-white p-2 rounded-full transition-colors"
                                    >
                                        ✕
                                    </button>
                                    <div className="text-6xl mb-4">{selectedChannel.icon}</div>
                                    <h2 className="text-2xl font-bold">{selectedChannel.name}</h2>
                                    <p className="opacity-90">{selectedChannel.fullName}</p>
                                </div>

                                <div className="p-8">
                                    <div className="mb-6">
                                        <h3 className="text-lg font-bold text-[#1E3A8A] mb-2">Deskripsi</h3>
                                        <p className="text-gray-600">{selectedChannel.description}</p>
                                    </div>

                                    <div className="mb-6">
                                        <h3 className="text-lg font-bold text-[#1E3A8A] mb-3">Fitur Unggulan</h3>
                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                            {selectedChannel.features.map((feature, index) => (
                                                <div key={index} className="flex items-center bg-gray-50 p-3 rounded-lg">
                                                    <FaStar className="text-yellow-500 mr-3 flex-shrink-0" />
                                                    <span className="text-sm text-gray-700">{feature}</span>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    <div className="mb-6">
                                        <h3 className="text-lg font-bold text-[#1E3A8A] mb-3">Cara Menggunakan</h3>
                                        <ol className="space-y-3">
                                            {selectedChannel.steps.map((step, index) => (
                                                <li key={index} className="flex items-start">
                                                    <div className="flex-shrink-0 w-8 h-8 bg-[#0D9488] text-white rounded-full flex items-center justify-center text-sm font-bold mr-3 mt-0.5">
                                                        {index + 1}
                                                    </div>
                                                    <span className="text-gray-700">{step}</span>
                                                </li>
                                            ))}
                                        </ol>
                                    </div>

                                    <div className="flex flex-col md:flex-row gap-4">
                                        {selectedChannel.website && (
                                            <a
                                                href={selectedChannel.website}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="btn-primary flex-1 flex items-center justify-center"
                                            >
                                                {selectedChannel.id === 'whatsapp' ? (
                                                    <FaWhatsapp className="mr-2" />
                                                ) : selectedChannel.id === 'email' ? (
                                                    <FaEnvelope className="mr-2" />
                                                ) : selectedChannel.id === 'telepon' ? (
                                                    <FaPhone className="mr-2" />
                                                ) : (
                                                    <FaExternalLinkAlt className="mr-2" />
                                                )}
                                                {selectedChannel.id === 'whatsapp' ? 'Chat WhatsApp' :
                                                    selectedChannel.id === 'email' ? 'Kirim Email' :
                                                        selectedChannel.id === 'telepon' ? 'Hubungi Sekarang' :
                                                            'Kunjungi Website'}
                                            </a>
                                        )}
                                        <button
                                            onClick={() => setSelectedChannel(null)}
                                            className="flex-1 border border-gray-300 rounded-lg px-6 py-2 text-gray-700 hover:bg-gray-50 transition-colors"
                                        >
                                            Tutup
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            )}

            {/* Mekanisme */}
            {activeTab === 'mekanisme' && (
                <div>
                    <div className="relative">
                        {/* Timeline */}
                        <div className="absolute left-8 top-0 bottom-0 w-0.5 bg-[#0D9488]/20 hidden md:block"></div>

                        <div className="space-y-8">
                            {aduanData.info.steps.map((item, index) => (
                                <div key={index} className="relative flex items-start">
                                    <div className="flex-shrink-0 w-16 h-16 bg-gradient-to-br from-[#0D9488] to-[#1E3A8A] rounded-full flex items-center justify-center text-white font-bold text-xl shadow-lg z-10">
                                        {item.step}
                                    </div>

                                    <div className="ml-6 card-glass flex-1">
                                        <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-3">
                                            <h3 className="text-xl font-bold text-[#1E3A8A]">{item.title}</h3>
                                            <span className="text-sm bg-[#0D9488]/10 text-[#0D9488] px-3 py-1 rounded-full font-medium mt-2 md:mt-0 inline-block w-fit">
                                                <FaClock className="inline mr-1" />
                                                {item.duration}
                                            </span>
                                        </div>
                                        <p className="text-gray-600">{item.description}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Jaminan */}
                    <div className="mt-12 card-glass bg-gradient-to-r from-[#1E3A8A] to-[#0D9488] text-white">
                        <h3 className="text-xl font-bold mb-6 flex items-center">
                            <FaShieldAlt className="mr-2" />
                            Jaminan Layanan Pengaduan
                        </h3>
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                            {aduanData.info.guarantee.map((item, index) => (
                                <div key={index} className="flex items-center bg-white/10 p-4 rounded-lg">
                                    <FaCheckCircle className="text-green-300 mr-3 flex-shrink-0 text-xl" />
                                    <span className="text-sm">{item}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            )}

            {/* Panduan */}
            {activeTab === 'panduan' && (
                <div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
                        {/* Yang Bisa Diadukan */}
                        <div className="card-glass">
                            <h3 className="text-xl font-bold text-[#1E3A8A] mb-6 flex items-center">
                                <FaCheckCircle className="mr-2 text-green-500" />
                                Yang Bisa Diadukan
                            </h3>
                            <ul className="space-y-3">
                                {[
                                    'Pelayanan yang tidak sesuai standar',
                                    'Pungutan liar (pungli)',
                                    'Penyalahgunaan wewenang',
                                    'Pelanggaran prosedur',
                                    'Fasilitas publik yang rusak',
                                    'Pengelolaan keuangan tidak transparan',
                                    'Aset daerah yang tidak terkelola',
                                    'Pelayanan administrasi yang lambat'
                                ].map((item, index) => (
                                    <li key={index} className="flex items-start">
                                        <FaCheckCircle className="text-green-500 mt-1 mr-3 flex-shrink-0" />
                                        <span className="text-gray-700">{item}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Tips Pengaduan */}
                        <div className="card-glass">
                            <h3 className="text-xl font-bold text-[#1E3A8A] mb-6 flex items-center">
                                <FaInfoCircle className="mr-2 text-blue-500" />
                                Tips Pengaduan Efektif
                            </h3>
                            <ul className="space-y-3">
                                {[
                                    'Jelaskan kronologi dengan jelas dan rinci',
                                    'Sebutkan waktu dan tempat kejadian',
                                    'Lampirkan bukti pendukung (foto/video)',
                                    'Gunakan bahasa yang sopan',
                                    'Cantumkan kontak yang bisa dihubungi',
                                    'Simpan nomor tiket pengaduan',
                                    'Pantau status pengaduan secara berkala',
                                    'Berikan feedback setelah pengaduan selesai'
                                ].map((item, index) => (
                                    <li key={index} className="flex items-start">
                                        <FaStar className="text-yellow-500 mt-1 mr-3 flex-shrink-0" />
                                        <span className="text-gray-700">{item}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>

                    {/* Statistik */}
                    {/*<div className="card-glass">
                        <h3 className="text-xl font-bold text-[#1E3A8A] mb-6">Statistik Pengaduan 2024</h3>
                        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                            <div className="bg-blue-50 p-4 rounded-lg text-center">
                                <p className="text-3xl font-bold text-blue-600">150</p>
                                <p className="text-sm text-gray-600">Total Pengaduan</p>
                            </div>
                            <div className="bg-green-50 p-4 rounded-lg text-center">
                                <p className="text-3xl font-bold text-green-600">142</p>
                                <p className="text-sm text-gray-600">Terselesaikan</p>
                            </div>
                            <div className="bg-yellow-50 p-4 rounded-lg text-center">
                                <p className="text-3xl font-bold text-yellow-600">8</p>
                                <p className="text-sm text-gray-600">Dalam Proses</p>
                            </div>
                            <div className="bg-purple-50 p-4 rounded-lg text-center">
                                <p className="text-3xl font-bold text-purple-600">95%</p>
                                <p className="text-sm text-gray-600">Tingkat Penyelesaian</p>
                            </div>
                        </div>
                    </div>*/}
                </div>
            )}
        </div>
    );
};

export default AduanPage;